import React from "react";
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { preprocessMentionsForMarkdown } from "../utils/mentionUtils";
import { sanitizeUrl } from "../utils/urlSanitizer";
import { cleanMarkdownWhitespace } from "../utils/markdownDetect";

const inlineHeading = ({ children }) => <strong>{children}</strong>;

const MarkdownPreview = ({ text, strings, className }) => {
  if (!text) return null;
  const cleaned = cleanMarkdownWhitespace(text);
  const processed = preprocessMentionsForMarkdown(cleaned, strings);
  return (
    <span className={className}>
      <Markdown
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm, remarkBreaks]}
        skipHtml={false}
        components={{
          p: ({ children }) => <>{children}</>,
          h1: inlineHeading,
          h2: inlineHeading,
          h3: inlineHeading,
          h4: inlineHeading,
          h5: inlineHeading,
          h6: inlineHeading,
          blockquote: ({ children }) => <>{children}</>,
          pre: ({ children }) => <>{children}</>,
          code: ({ children }) => <>{children}</>,
          br: () => <> </>,
          ul: ({ children }) => <>{children}</>,
          ol: ({ children }) => <>{children}</>,
          li: ({ children, ordered, index }) => <span>{ordered ? `${index + 1}. ` : '• '}{children} </span>,
          strong: ({ children }) => <strong>{children}</strong>,
          b: ({ children }) => <strong>{children}</strong>,
          em: ({ children }) => <em>{children}</em>,
          u: ({ children }) => <u>{children}</u>,
          del: ({ children }) => <del>{children}</del>,
          a: ({ href, children }) => (
            <a href={sanitizeUrl(href)} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
          script: () => null,
          iframe: () => null,
        }}
      >
        {processed}
      </Markdown>
    </span>
  );
};

export default MarkdownPreview;
